import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components';

export const popup = css`
  position: relative;
  width: 410px;
  display: flex;
  pointer-events: all;
  flex-direction: column;
`;

export const header = css`
  display: flex;
  align-items: center;
  min-height: 25px;
  justify-content: space-between;
`;

export const titleWrapper = css`
  display: flex;
  flex-direction: column;
  padding: 17px 20px;
  background: ${colors.gray.lightest};
`;

export const subTitle = css`
  padding-top: 10px;
`;

export const badge = css`
  display: flex;
  align-items: center;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.medium};

  & svg {
    margin-right: 10px;
    width: ${icons.size.smallest};
    height: ${icons.size.smallest};
  }
`;

export const badgeDefault = css`
  font-weight: ${fonts.weight.regular};
  background-color: ${colors.shadows.getShadow(colors.gray.dark, 0.1)};
  color: ${colors.gray.dark};
`;

export const badgeClient = css`
  background-color: ${colors.shadows.getShadow(colors.success.default, 0.1)};
  color: ${colors.success.default};
`;

export const badgeBase = css`
  background-color: ${colors.shadows.getShadow(colors.primary.default, 0.1)};
  color: ${colors.primary.default};
`;

export const badgeOther = css`
  background-color: ${colors.shadows.getShadow(colors.warning.default, 0.1)};
  color: ${colors.warning.default};
`;

export const body = css`
  padding: 20px;

  & > span:not(#address) {
    display: block;
  }

  & > span:not(:first-child) {
    margin-top: 10px;
  }
`;

export const addressPlaceholder = css`
  vertical-align: middle;
`;

export const idleHighlight = css`
  display: inline-flex;
  padding: 10px;
  border-radius: 5px;
  margin-top: 15px;
  background: ${colors.shadows.getShadow(colors.warning.default, 0.1)};

  & > svg {
    margin-right: 10px;
    color: ${colors.warning.default};
    font-size: ${icons.size.medium};
  }
`;

export const trackingActionArea = css`
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: 1px solid ${colors.gray.light};
`;
